module.exports = __webpack_public_path__ + "img/playtesting.46c56ca0.png";